import React from "react";
import { validateEditCustomer } from "../../utils/editCustomer";

export const SubmitEditCustomer = ({ title, idButton }) => {
    return (
        <button type="submit" className="btn btn-outline-light" id={idButton} onClick={validateEditCustomer} >{title}</button>
    );
}